/* eslint-disable */

//tslint:disable

import { IModel, IModelResponse } from '@cian/http-api/shared/model';

export type TSendIncrementModel = IModel<ISendIncrementRequest, TSendIncrementResponse>;

export interface ISendIncrementRequest {
  /** Ключ по которому делаем инкримент **/
  key: string;
  /** Значение по умолчанию 1 **/
  value?: number | null;
}

export type TSendIncrementResponse = ISendIncrementResponse200 | ISendIncrementResponse400;

export interface ISendIncrementResponse200 extends IModelResponse<ISendIncrementResponse> {
  statusCode: 200;
}

export interface ISendIncrementResponse400 extends IModelResponse<ISendIncrementResponseError> {
  statusCode: 400;
}

export interface ISendIncrementResponse {
  /** Статус ответа **/
  status: EStatus;
}

export interface ISendIncrementResponseError {
  errors: any[];
  message: string;
}

export type TResponses = ISendIncrementResponse | ISendIncrementResponseError;

export enum EStatus {
  /** OK **/
  Ok = 'ok',
}

export interface IMappers<TResponse200, TResponse400> {
  200(response: ISendIncrementResponse): TResponse200;
  400(response: ISendIncrementResponseError): TResponse400;
}
